import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { FaRegEdit } from "react-icons/fa";
import * as Yup from 'yup'
import Swal from "sweetalert2";
import * as bie from "react-bootstrap";
import { allowAlphabetAndSpacesOnly } from "../../CommonUtils/CommonValidations";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { failureAlert, successAlertRefresh } from "../../CommonUtils/SweetAlerts";
import { BiTrash } from "react-icons/bi";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";

export default function AfflNonTeachingEmployeeDetails() {
    const userid = (sessionStorage.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage.getItem('user_id').split('_')[1] : sessionStorage.getItem('user_id');
    const [getdata, setdata] = useState([]);
    const NonTeachingEmplDtlsValidation = Yup.object().shape({
        empName: Yup.string().required(ERROR_MSG).nullable(),
        designation: Yup.string().required(ERROR_MSG).nullable(),
        dob: Yup.string().required(ERROR_MSG).nullable(),
        joiningDate: Yup.string().required(ERROR_MSG).nullable(),
        sectionName: Yup.string().required(ERROR_MSG).nullable(),
        otherSection: Yup.string().when('sectionName', {
            is: 'Others',
            then: Yup.string().required(ERROR_MSG),
            otherwise: Yup.string().nullable(),
        }),
    });
    const NonTeachingformik = useFormik({
        enableReinitialize: true,
        initialValues: {
            "dob": "",
            "empId": 0,
            "empName": "",
            "sectionName": "",
            "otherSection": "",
            "designation": "",
            "joiningDate": ""
        },
        validationSchema: NonTeachingEmplDtlsValidation,
        onSubmit: (val) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config?.url?.API_URL + `nonTeachingDetails`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlertRefresh(res?.data?.sdesc);
                        }
                        else {
                            failureAlert("Failed to submit")
                        }
                    })
                }
            })
        }
    })
    function getDetails() {
        let url = config.url.API_URL + `getNonTeachingDetails` + "/" + userid;
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {
                setdata(res?.data?.nonTeachingData);
            }
            else {
                setdata([]);
            }
        });

    }
    function DeleteRow(empId) {
        Swal.fire({
            title: "Are you sure want to delete the data?",
            showDenyButton: false,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                let payload = {
                    empId: empId
                }
                let url = `${config.url.API_URL}deleteNonTchEmployee`
                CommonAxiosPost(url, payload).then((res) => {
                    if (res?.data?.scode === '01') {
                        successAlertRefresh(res?.data?.sdesc)

                    }
                    else {
                        Swal.fire('Failed to Delete')
                    }
                })
            }
        })
    }
    function EditRow(rowdata) {
        NonTeachingformik.setFieldValue("dob", rowdata?.dob ?? '', false);
        NonTeachingformik.setFieldValue("empName", rowdata?.emp_name ?? '', false);
        NonTeachingformik.setFieldValue("sectionName", rowdata?.section_name ?? '', false);
        if (rowdata?.section_name === "Others") {
            NonTeachingformik.setFieldValue("otherSection", rowdata?.other_section ?? '', false);
        }
        else {
            NonTeachingformik.setFieldValue("otherSection", "");
        }
        NonTeachingformik.setFieldValue("designation", rowdata?.designation ?? '', false);
        NonTeachingformik.setFieldValue("joiningDate", rowdata?.joining_date ?? '', false);
        NonTeachingformik.setFieldValue("empId", rowdata?.emp_id ?? '', false);
        NonTeachingformik.validateForm();

    }
    useEffect(() => {
        getDetails();
    }, []);
    return (
        <>
            <bie.Container fluid className="px-1">
                <CommonFormHeading heading={"Non Teaching Staff Details"} />
                <bie.Container className="outer-page-content-container shadow-none px-5 m-0 mw-100 pb-5">


                    <FormikProvider value={NonTeachingformik}>
                        <Form onChange={NonTeachingformik.handleChange} onSubmit={NonTeachingformik.handleSubmit} className="form_adjust affl-form">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0"> Non Teaching Staff Details</h1>
                            </div>
                            <bie.Row className="px-2 my-3">
                                <bie.Col xs={12} md={6} lg={4}>
                                    <label classname='mb-1'><b className="field-mandatory"> Employee Name:</b></label>
                                    <bie.InputGroup>
                                        <Field type="text" name="empName" className="form-control mb-2" placeholder="Employee Name" maxLength="50"
                                            onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} />
                                        <ErrorMessage name="empName" component="div" className="text-error" />
                                    </bie.InputGroup>
                                </bie.Col>
                                <bie.Col xs={12} md={6} lg={4}>
                                    <label classname='mb-1'><b className="field-mandatory">Designation:</b></label>
                                    <bie.InputGroup>
                                        <Field type="text" name="designation" className="form-control mb-2" placeholder="designation" maxLength="40"
                                            onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} />
                                        <ErrorMessage name="designation" component="div" className="text-error" />
                                    </bie.InputGroup>
                                </bie.Col>
                                <bie.Col xs={12} md={6} lg={4}>
                                    <label classname='mb-1'><b className="field-mandatory">
                                        Date Of Birth:
                                    </b></label>
                                    <bie.InputGroup>
                                        <Field type="date" name="dob" className="form-control mb-2" onKeyDown={(e) => { e.preventDefault() }} max={(() => {
                                            const today = new Date();
                                            today.setFullYear(today.getFullYear() - 15);
                                            return today.toISOString().split("T")[0];
                                        })()} />
                                        <ErrorMessage name="dob" component="div" className="text-error" />
                                    </bie.InputGroup></bie.Col>
                                <bie.Col xs={12} md={6} lg={4}>
                                    <label classname='mb-1'><b className="field-mandatory">
                                        Date of Joining in college:
                                    </b></label>
                                    <bie.InputGroup>
                                        <Field type="date" name="joiningDate" className="form-control mb-2" onKeyDown={(e) => { e.preventDefault() }} min={
                                            NonTeachingformik.values.dob
                                                ? (() => {
                                                    const dob = new Date(NonTeachingformik?.values?.dob);
                                                    dob.setFullYear(dob.getFullYear() + 15); // Add 21 years to dateOfBirth
                                                    return dob.toISOString().split("T")[0]; // Format as YYYY-MM-DD
                                                })()
                                                : ""
                                        } />
                                        <ErrorMessage name="joiningDate" component="div" className="text-error" />
                                    </bie.InputGroup></bie.Col>
                                <bie.Col xs={12} md={6} lg={3}>
                                    <label classname='mb-1'> <b className="field-mandatory">
                                        Section:
                                    </b></label>
                                    <bie.InputGroup>
                                        <Field as="select" name="sectionName" className="form-control " >
                                            < option value="" >--Select Section--</ option>
                                            < option value="Administration section" >Administration section</ option>
                                            < option value="Accounts section" >Accounts section</ option>
                                            < option value="Library" >Library</ option>
                                            < option value="Examination Section" >Examination Section</ option>
                                            < option value="Laboratory" >Laboratory</ option>
                                            < option value="Others" >Others</ option>
                                        </Field>
                                        <ErrorMessage name="sectionName" component="div" className="text-error" />
                                    </bie.InputGroup></bie.Col>
                                {NonTeachingformik?.values?.sectionName === 'Others' && (<>
                                    <bie.Col xs={12} md={6} lg={3} >
                                        <label classname='mb-1'><b className="field-mandatory"> Others - Please Specify:</b></label>
                                        <bie.InputGroup>
                                            <Field type="text" name="otherSection" className="form-control mb-2" placeholder="Other Section" />
                                            <ErrorMessage name="otherSection" component="div" className="text-error" />
                                        </bie.InputGroup>  </bie.Col>


                                </>)}
                                <bie.Col xs={12} md={6} lg={3}>
                                    <div className=" mt-3">
                                        <button type='submit' className='btn btn-success mt-2'>Submit</button>
                                    </div>
                                </bie.Col>

                            </bie.Row>

                        </Form>
                    </FormikProvider>


                    {getdata && getdata?.length > 0 && (
                        <>
                            <div className="inner-herbpage-service-title-sub mt-3"  >
                                <h1 className="">Non-Teaching Details Report</h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>Name of the Employee</th>
                                            <th>Date of Birth</th>
                                            <th>Designation</th>
                                            <th>Section</th>
                                            <th>Date of Joining</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getdata?.length > 0 && getdata.map((areadet, i) => (
                                            <tr>
                                                <td style={{ textAlign: "left" }}>{areadet?.emp_name}</td>
                                                <td>{areadet?.dob || '-'}</td>
                                                <td className="text-left">{areadet?.designation}</td>
                                                <td className="text-left">{areadet?.sec_name}</td>
                                                <td>{areadet?.joining_date}</td>
                                                <td style={{ textAlign: 'center' }}>
                                                    <button type='button' className='btn btn-warning btn-sm text-white' onClick={() => EditRow(areadet)}><FaRegEdit /></button>&emsp;&emsp;
                                                    <button type='button' className='btn btn-danger btn-sm' onClick={() => DeleteRow(areadet?.emp_id)}><BiTrash /></button></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </bie.Container>
            </bie.Container >
        </>
    )
}

